var r = /* @__PURE__ */ ((e) => (e.NEUTRAL = "neutral", e.POSITIVE = "positive", e.INFORMATIVE = "informative", e.NEGATIVE = "negative", e))(r || {});
export {
  r as TOAST_VARIANT
};
//# sourceMappingURL=toast-variants.js.map
